export default "__VITE_PUBLIC_ASSET__9a04407b__"